import {api, authApi} from "../../src/api";
import {setModalContent} from "../../src/modals";
import {memberSearchTagify} from "../../src/tagify";
import {Notifications} from "../../src/notifications";
import {Validation} from "../../src/validation";
import {composeEmail} from "../../src/emails";
import {FreezeUI} from "../../src/freeze-ui";
import {HandlebarsHelpers, noResultsTemplate} from "../../src/handlebarsHelpers";
import {trackException} from "../../src/errors";
import {initTooltips} from "../../src/tooltips";
import Tabs from "../../src/tabs";

let bookingUpdatedEvent = new Event('booking.updated');
let sessionId, sessionDate;

document.addEventListener("DOMContentLoaded", async () => {

    new Tabs(document.querySelector("[data-collapse-menu]"));

    const sessionHeader = document.querySelector("#session_header");
    sessionId = sessionHeader?.dataset.sessionId;
    sessionDate = sessionHeader?.dataset.sessionDate;

    initTemplates();

    await updateBookingsUI();

    document.addEventListener("bookingupdated", async () => {
        await updateBookingsUI();
    });

    //#region Add Coach Events

    document.querySelectorAll("[data-add-coach]").forEach(el => {
        el.addEventListener("click", async e => {
            e.preventDefault();

            await showAddCoachForm(el);
        });
    });

    //#endregion Add Coach Events

    //#region Add Booking Events

    document.querySelectorAll("[data-add-booking]").forEach(el => {
        el.addEventListener("click", async e => {
            e.preventDefault();

            await showAddBookingForm(el);
        });
    });

    //#endregion Add Bookings Events

    //#region Send Emails Events

    document.querySelector("[data-email-participants]")?.addEventListener("click", async e => {
        e.preventDefault();

        FreezeUI.Freeze();
        const subject = e.currentTarget.dataset.subject;

        const {data} = await authApi.get(`/api/bookings?sessionId=${sessionId}&SessionDate=${sessionDate}&BookingStatus=coach&BookingStatus=confirmed&Limit=100&include=memberId,name`);
        const recipients = data.items.map(item => {
            return item.memberId;
        });

        await composeEmail([{
            value: recipients.join('|'),
            text: `${recipients.length} Members`
        }], subject);

        FreezeUI.UnFreeze();
    });

    //#endregion Send Emails Events

    //#region Book Button Events

    document.addEventListener("click", async e => {
        const target = e.target.closest("[data-action='Book'][data-booking-type='Coach']")
        if (!target)
            return;

        await handleCoachBooking(e, target);
    });

    document.addEventListener("click", async e => {
        const target = e.target.closest("[data-action='Book'][data-booking-type='Participant']")
        if (!target)
            return;

        await handleParticipantBooking(e, target);
    });

    document.addEventListener("click", async e => {
        const target = e.target.closest("[data-action='Cancel']")
        if (!target)
            return;

        await handleCancelBooking(e, target);
    });

    //#endregion Book Events

});

//#region Modals

const showAddCoachForm = async (el) => {
    const modalUrl = el.href;

    const {data} = await api.get(modalUrl);
    const modal = setModalContent(data);

    const tagify = memberSearchTagify("#Members", false);

    const form = modal._element.querySelector("form");
    const saveButton = modal._element.querySelector("[data-save=\"modal\"]")

    saveButton.addEventListener("click", async e => {
        e.preventDefault();

        Validation.disableButton(saveButton);
        const members = tagify.value.map(e => {
            return e.value
        });

        if (members.length <= 0) {
            Notifications.showWarning({ message: "Please select at least one member to add." });
            return;
        }

        try {
            await api.post(form.action, {
                members
            });

            document.dispatchEvent(bookingUpdatedEvent);
            Notifications.showSuccess({ message: "The coaches have been added." });
            modal.hide();

            await updateBookingsUI();
        } catch (ex) {
            trackException(ex);
            Validation.enableButton(saveButton);
            Notifications.showError({ message: "There was an error adding the coach." });
        }
    });
}

const showAddBookingForm = async (el) => {
    const modalUrl = el.href;

    const {data} = await api.get(modalUrl);
    const modal = setModalContent(data);

    const tagify = memberSearchTagify("#Members", false);

    const form = modal._element.querySelector("form");
    const saveButton = modal._element.querySelector("[data-save=\"modal\"]")

    saveButton.addEventListener("click", async e => {
        e.preventDefault();

        Validation.disableButton(saveButton);
        const members = tagify.value.map(e => {
            return e.value
        });

        if (members.length <= 0) {
            Notifications.showWarning({ message: "Please select at least one member to add." });
            return;
        }

        const sendEmails = form.querySelector("#SendEmails").checked;

        await api.post(form.action, { members, sendEmails})
            .then(async () => {
                Validation.enableButton(saveButton);
                document.dispatchEvent(bookingUpdatedEvent);

                await updateBookingsUI();

                Notifications.showSuccess({ message: "The member has been added to the session." });
                modal.hide();
            })
            .catch(ex => {
                console.error(ex);
                trackException(ex);
                Notifications.showError({ message: "There was an error creating the booking." });
                Validation.enableButton(saveButton);
            });
    });
}

//#endregion Modals

//#region Booking UI Updates

    const updateBookingsUI = async () => {

        await authApi.get(`/api/sessions/bookings/${sessionId}/${sessionDate}`)
            .then(response => {
                updateCounts("[data-bookings-badge]", response.data.confirmedCount);
                updateCounts("[data-waiting-badge]", response.data.waitingListCount);
                updateCounts("[data-coaches-badge]", response.data.coachCount);

                updateConfirmedTable(response.data.bookings);
                updateWaitingListTable(response.data.bookings);
                updateCancelledTable(response.data.bookings);
                updateCoachesTable(response.data.bookings);

                initTooltips(document.querySelector("#bookings_container"));
                refreshFsLightbox();
            })
            .catch(ex => {
                console.error(ex);
            });
    }

    const updateConfirmedTable = (bookings) => {

        if(!bookings)
            return;

        const container = document.querySelector("#tab_bookings .content");
        const confirmedBookings = bookings.filter((el) => {
            return el.bookingStatus === "Confirmed";
        });

        if (confirmedBookings.length > 0) {
            const listTemplate = Handlebars.compile(bookingsTableTemplate);
            container ? container.innerHTML = listTemplate(confirmedBookings) : null;
        } else {
            container ? container.innerHTML = noResultsTemplate("There are no bookings for this session.") : null;
        }
    }

    const updateWaitingListTable = (bookings) => {
        if (!bookings)
            return;

        const container = document.querySelector("#tab_bookings .content");
        const waiting = bookings.filter((el) => {
            return el.bookingStatus === "WaitingList";
        });

        if (waiting.length > 0) {
            const listTemplate = Handlebars.compile(bookingsTableTemplate);
            const headerTemplate = Handlebars.compile(waitingListTemplate);

            container ? container.innerHTML += headerTemplate() : null;
            container ? container.innerHTML += listTemplate(waiting) : null;
        }
    }

    const updateCancelledTable = (bookings) => {
        if (!bookings)
            return;

        const cancelled = bookings.filter((el) => {
            return el.bookingStatus === "Cancelled";
        });

        if (cancelled.length > 0) {
            const listTemplate = Handlebars.compile(cancelledTableTemplate);
            const headerTemplate = Handlebars.compile(cancelledTemplate);

            const sortedBookings = cancelled.sort(function (a, b) {
                if (a.dateCancelled < b.dateCancelled) {
                    return -1;
                }
                if (a.dateCancelled > b.dateCancelled) {
                    return 1;
                }

                return 0;
            });

            const container = document.querySelector("#tab_bookings .content");
            container ? container.innerHTML += headerTemplate() : null;
            container ? container.innerHTML += listTemplate(cancelled) : null;
        }
    }

    const updateCoachesTable = (bookings) => {
        if (!bookings)
            return;

        const container = document.querySelector("#tab_coaches .content");
        const coaches = bookings.filter((el) => {
            return el.bookingStatus === "Coach";
        });

        if (coaches.length > 0) {
            const listTemplate = Handlebars.compile(coachTableTemplate);
            container ? container.innerHTML = listTemplate(coaches) : null;
        } else {
            container ? container.innerHTML = noResultsTemplate("There are no coaches for this session.") : null;
        }
    }

    const updateCounts = (selector, count) => {
        document.querySelectorAll(selector).forEach(el => {
            el.innerHTML = count;
        });
    }
//#endregion Booking Updates

//#region Book Button Handlers

const handleCoachBooking = async (e, el) => {

    try {
        FreezeUI.Freeze();

        await authApi.post("/api/bookings", { sessionId, sessionDate, BookingType: "Coach"});

        await updateBookingsUI();
        Notifications.setNotificationCookie("Your booking has been confirmed.")

        location.reload();

    } catch (ex) {
        trackException(ex);
        console.error(ex);
        FreezeUI.UnFreeze();
        Notifications.showError({ message: "There was an error making your booking. Please try again later." });
    }
};

const handleParticipantBooking = async (e, el) => {

    e.preventDefault();
    const modalUrl = el.href;

    FreezeUI.Freeze();

    const {data} = await api.get(modalUrl);
    const modal = setModalContent(data);

    FreezeUI.UnFreeze();

    const form = modal._element.querySelector("#book_form");
    const validator = Validation.getDefaultValidator(form);

    form.addEventListener("submit", (e) => {
        e.preventDefault();

        validator.validate().then(async status => {
            if (status === 'Valid') {
                Validation.disableButton(e.submitter);

                let fields = {};
                form.querySelectorAll("[id^=field_]").forEach(input => {
                    fields[input.id.replace('field_', '')] = input.value;
                });

                const paymentMethodEl = document.querySelector("input[name=\"PaymentMethods\"]:checked");

                const paymentMethod = paymentMethodEl?.value ?? null;
                const passInstanceId = paymentMethod === "Pass" ? paymentMethodEl.dataset.passInstanceId : null;

                await authApi.post("/api/bookings", {
                    sessionId,
                    sessionDate,
                    fields,
                    paymentMethod,
                    passInstanceId
                })
                .then(async ({data}) => {
                    if (data.paymentUrl) {
                        window.location = data.paymentUrl;
                    } else {
                        await updateBookingsUI();
                        Notifications.setNotificationCookie("Your booking has been confirmed.")

                        location.reload();
                    }
                })
                .catch((ex) => {
                    trackException(ex);
                    console.error(ex);

                    Notifications.showError({ message: ex.response.data ?? "There was a problem creating your booking. Please try again later." });
                    Validation.enableButton(e.submitter);
                });

            }
        });

    });
}

const handleCancelBooking = async (e, el) => {
    e.preventDefault();

    const bookingId = el.dataset.bookingId;
    const refundWindow = el.dataset.refundWindow;
    const refundWindowCloses = new Date(el.dataset.refundWindowCloses);
    const bookingCost = parseFloat(el.dataset.bookingCost ?? 0);

    let message = `<p>Your booking will be cancelled.</p>`;
    if(bookingCost > 0 && refundWindow > 0 && new Date() > refundWindowCloses) {
        message += `<p>Bookings cancelled within <strong>${refundWindow}</strong> hours of the session will not be refunded.</p>`;
    }

    const {isConfirmed} = await Notifications.confirm.fire({
        title: "Cancel Booking?",
        html: message
    });

    if (isConfirmed) {

        try {
            FreezeUI.Freeze();
            const {data} = await authApi.put(`/api/bookings/cancel/${bookingId}`);

            await updateBookingsUI();
            Notifications.setNotificationCookie("Your booking has been cancelled.");

            location.reload();
        } catch(ex){
            trackException(ex);
            Notifications.showError({ message: "There was an error cancelling your booking. Please try again later." })
        }
        finally {
            FreezeUI.UnFreeze();
        }
    }
}

//#endregion Booking

//#region Templates

const initTemplates = () => {
    HandlebarsHelpers.init();
    Handlebars.registerPartial("avatar", avatarTemplate);
}

const avatarTemplate = `
    <div class="symbol symbol-30 flex-shrink-0 me-5 d-none d-sm-block">
        <a href="/images/avatar/{{memberId}}?w=800" data-fslightbox="lightbox-basic">
            <img srcset="
                         /images/avatar/{{memberId}}?w=200 4x,
                         /images/avatar/{{memberId}}?w=150 3x,
                         /images/avatar/{{memberId}}?w=100 2x"
                 src="/images/avatar/{{memberId}}?w=50" alt="{{name}}" class="w-30px rounded">
        </a>
    </div>`;

const bookingsTableTemplate = `
    {{#each @root}}
        <div class="tab-pane fade show active" id="tab_bookings" role="tabpanel">
            <div class="d-flex align-items-center justify-content-between bg-hover-light px-5 py-2">
                {{>avatar }}
                <div class="flex-grow-1 py-2 d-flex align-items-center">
                    <span class="badge badge-circle fw-bold fs-7 status-{{membershipStatus}} me-2 w-15px h-15px" data-bs-toggle="tooltip" data-bs-placement="top" title="Membership status is {{membershipStatus}}"></span>
                    <a class='text-gray-800 text-hover-primary' href="/memberdetails/{{memberId}}" data-bs-toggle="ajax-modal">{{name}}</a>
                </div>
               <div class='d-flex align-items-center gap-2 me-2'>
                   {{#ifEquals attended false}}
                       <i class="bi bi-exclamation-triangle text-warning fs-3" title="Did not attend the session" data-bs-toggle="tooltip"></i>
                   {{/ifEquals}}
                   {{#ifEquals attended true}}
                       <i class="bi bi-check fs-1 text-success" title="Attended the session" data-bs-toggle="tooltip"></i>
                   {{/ifEquals}}
                   {{#if isFirstSession}}
                       <span class="badge badge-warning">First Session</span>
                   {{/if}}
                    {{#if paymentRequired}}
                       <span class="badge badge-light-danger label-inline" data-mark-paid='{{id}}'>Not paid</span>
                    {{/if}}
                   {{#ifGreaterThan 18 age}}
                       <span class="badge badge-danger">Under 18</span>
                   {{/ifGreaterThan}}
                   {{#unlessObjectEmpty formValues}}
                       <a href="/bookingnotes/{{id}}" data-bs-toggle="ajax-modal"><span data-placement="top" data-bs-toggle="tooltip" title="This booking has notes." class="bi bi-journal-text fs-3"></span></a>
                   {{/unlessObjectEmpty}}
               </div>
                <div class="dropdown dropdown-inline">
                    <button type="button" class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary" data-bs-toggle="dropdown">
                        <i class="bi bi-three-dots fs-3"></i>
                    </button>
                    <div class="dropdown-menu menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px py-3">
                        <div class="menu-item px-3">
                            <a href="#" class="menu-link px-3" title="Send Email" data-send-email data-member-id="{{memberId}}" data-member-name="{{name}}">
                                <span class="menu-icon">
                                    <i class="bi bi-envelope-at fs-3"></i>
                                </span>
                                <span>
                                    Send Email
                                </span>
                            </a>
                        </div>
                        <div class="menu-item px-3">
                            <a href="/memberdetails/{{memberId}}" class="menu-link px-3" title="View Details" data-bs-toggle="ajax-modal">
                                <span class="menu-icon">
                                    <i class="bi bi-person fs-3"></i>
                                </span>
                                <span>
                                    View Profile
                                </span>
                            </a>
                        </div>
                        <div class="menu-item px-3">
                            <a href="/bookingdetails/{{id}}" class="menu-link px-3" title="View Booking" data-bs-toggle="ajax-modal">
                                <span class="menu-icon">
                                    <i class="bi bi-credit-card-2-front fs-3"></i>
                                </span>
                                <span>
                                    View Booking
                                </span>
                            </a>
                        </div>
                       {{#if paymentRequired}}
                        <div class="menu-item px-3">
                            <a href="#" class="menu-link px-3" title="Mark as Paid" data-mark-paid='{{id}}'>
                                <span class="menu-icon">
                                    <i class="bi bi-cash-coin fs-3"></i>
                                </span>
                                <span>
                                    Mark as Paid
                                </span>
                            </a>
                        </div>
                        {{/if}}
                        <div class="menu-item px-3">
                            <a href="#" class="menu-link text-danger px-3" title="Cancel Booking" data-cancel-booking data-booking-id="{{id}}" data-member-id="{{memberId}}" data-member-name="{{name}}" data-is-paid="{{isPaid}}" data-cost="{{cost}}">
                                <span class="menu-icon">
                                    <i class="bi bi-person-x text-danger fs-3"></i>
                                </span>
                                <span>
                                    Cancel Booking
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    {{/each}}`;

const cancelledTableTemplate = `
    {{#each @root}}
        <div class="tab-pane fade show active" id="tab_bookings" role="tabpanel">
            <div class="d-flex align-items-center justify-content-between bg-hover-light px-5 py-2">
                {{>avatar }}
                <div class="flex-grow-1 py-2 d-flex align-items-center">
                    <span class="badge badge-light-danger badge-circle fw-bold fs-7 status-{{membershipStatus}} me-2 w-15px h-15px" data-bs-toggle="tooltip" data-bs-placement="top" title="Membership status is {{membershipStatus}}"></span>
                    <a class='text-gray-800 text-hover-primary' href="/memberdetails/{{memberId}}" data-bs-toggle="ajax-modal">{{name}}</a>
                </div>
                <div class='fs-7'>
                   {{formatDate dateCancelled "short"}}
                </div>
            </div>
        </div>
    {{/each}}`;

const coachTableTemplate = `
    {{#each @root}}
        <div class="tab-pane fade show active" id="tab_bookings" role="tabpanel">
            <div class="d-flex align-items-center justify-content-between bg-hover-light px-5 py-2">
                {{>avatar }}
                <div class="flex-grow-1 py-2 d-flex align-items-center">
                    <span class="badge badge-light-danger badge-circle fw-bold fs-7 status-{{membershipStatus}} me-2 w-15px h-15px" data-bs-toggle="tooltip" data-bs-placement="top" title="Membership status is {{membershipStatus}}"></span>
                    <a class='text-gray-800 text-hover-primary' href="/memberdetails/{{memberId}}" data-bs-toggle="ajax-modal">{{name}}</a>
                </div>
                <div class="dropdown dropdown-inline">
                    <button type="button" class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary" data-bs-toggle="dropdown">
                        <i class="bi bi-three-dots fs-3"></i>
                    </button>
                    <div class="dropdown-menu menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px py-3">
                        <div class="menu-item px-3">
                            <a href="#" class="menu-link px-3" title="Send Email" data-send-email data-member-id="{{memberId}}" data-member-name="{{name}}">
                                <span class="menu-icon">
                                    <i class="bi bi-envelope-at fs-3"></i>
                                </span>
                                <span>
                                    Send Email
                                </span>
                            </a>
                        </div>
                        <div class="menu-item px-3">
                            <a href="/memberdetails/{{memberId}}" class="menu-link px-3" title="View Details" data-bs-toggle="ajax-modal">
                                <span class="menu-icon">
                                    <i class="bi bi-person fs-3"></i>
                                </span>
                                <span>
                                    View Profile
                                </span>
                            </a>
                        </div>
                        <div class="menu-item px-3">
                            <a href="/bookingdetails/{{id}}" class="menu-link px-3" title="View Booking" data-bs-toggle="ajax-modal">
                                <span class="menu-icon">
                                    <i class="bi bi-credit-card-2-front fs-3"></i>
                                </span>
                                <span>
                                    View Booking
                                </span>
                            </a>
                        </div>
                        <div class="menu-item px-3">
                            <a href="#" class="menu-link px-3" title="Remove Coach" data-cancel-booking data-booking-id="{{id}}" data-member-id="{{memberId}}" data-member-name="{{name}}">
                                <span class="menu-icon">
                                    <i class="bi bi-person-x fs-3"></i>
                                </span>
                                <span>
                                    Remove Coach
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    {{/each}}`;

const waitingListTemplate = `
    <div class="bg-dark text-light fw-bold p-2 mt-10">Waiting List</div>`;

const cancelledTemplate = `
    <div class="bg-dark text-light fw-bold p-2 mt-10 d-flex justify-content-between">
       <div>Cancelled Bookings</div>
       <div>Date Cancelled</div>
    </div>`;

//#endregion Templates
